import { render } from "./MvMain1.vue?vue&type=template&id=27191bc3"
import script from "./MvMain1.vue?vue&type=script&lang=js"
export * from "./MvMain1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__